import { Switch } from "@chakra-ui/react";

interface SwitchInputProps {
    name: string;
    defaultChecked?: boolean;
    onChange: (e: { name: string; value: boolean }) => void;
}

const SwitchInput: React.FC<SwitchInputProps> = ({ name, defaultChecked = false, onChange }) => {
    return (
        <>
            <Switch
                colorScheme="blue"
                isChecked={defaultChecked}
                onChange={(e) => onChange({ name, value: e.target.checked })}
            />
            <input type="hidden" name={name} value={defaultChecked.toString()} />
        </>
    );
};

export default SwitchInput;
